var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-menu"},[_c('router-link',{attrs:{"to":"/about"}},[_vm._v(_vm._s(_vm.$t('about_menu.about')))]),_c('router-link',{attrs:{"to":"/history"}},[_vm._v(_vm._s(_vm.$t('about_menu.history')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }